import { PenLine } from "lucide-react";
import MoodCard from "./MoodCard";
import { MOOD_IDEAS } from "../lib/moods";

export default function MoodPicker({ moods, selected, onSelect, customMood, setCustomMood, onSubmit }) {
  const isCustom = selected === "custom";
  return (
    <section className="mt-10">
      <h2 className="font-extrabold text-2xl tracking-tight mb-4">Quel est ton mood ?</h2>
      <div data-testid="mood-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {moods.map((m) => (
          <MoodCard key={m.key} moodKey={m.key} mood={m} selected={selected === m.key} onClick={() => onSelect(m.key)} />
        ))}
        <button
          data-testid="mood-card-custom"
          onClick={() => onSelect("custom")}
          className={`relative text-left rounded-lg p-5 overflow-hidden sp-card border-2 border-dashed border-[#FF2E93]/60 ${isCustom ? "sp-mood-active" : ""}`}
        >
          <div className="h-14 w-14 rounded-md flex items-center justify-center bg-[#282828]">
            <PenLine className="h-6 w-6 text-[#FF2E93]" />
          </div>
          <div className="mt-4 font-extrabold text-base text-white tracking-tight">Mon mood</div>
          <div className="text-xs text-[#B3B3B3] mt-0.5">Décris-le avec tes mots</div>
        </button>
      </div>
      {isCustom && (
        <>
          <div className="mt-4 bg-[#181818] rounded-lg p-4">
            <input
              data-testid="custom-mood-input"
              autoFocus
              value={customMood}
              maxLength={120}
              onChange={(e) => setCustomMood(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onSubmit()}
              placeholder="ex : dimanche pluvieux sous un plaid, road trip au coucher du soleil..."
              className="w-full bg-[#242424] rounded-full px-5 py-3 text-white placeholder:text-[#6a6a6a] outline-none focus:ring-2 focus:ring-[#FF2E93]"
            />
          </div>
          <div data-testid="mood-ideas" className="mt-3 flex flex-wrap gap-2">
            {MOOD_IDEAS.map((idea, i) => (
              <button
                key={idea}
                data-testid={`mood-idea-${i}`}
                onClick={() => setCustomMood(idea)}
                className={`rounded-full px-3.5 py-1.5 text-xs font-semibold ${customMood === idea ? "sp-chip-active" : "sp-chip text-white"}`}
              >
                {idea}
              </button>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
